import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './sign-up.scss.js';

class SignUp extends s {
    render() {
        const headline = x `<slot name="headline"></slot>`;
        const bodyText = x `<slot name="body-text"></slot>`;
        const logo = x `<slot name="logo"></slot>`;
        const signUpClassMap = {
            bottom: this.isBottom || false,
            rtl: this.rtl || isRTL(),
        };
        return x `<div class="sign-up ${o(signUpClassMap)}"><div class="inner"><div class="col1">${this.isBottom ? headline : logo}</div><div class="col2">${this.isBottom ? logo : null} ${this.isBottom ? bodyText : headline}<slot name="cta"></slot></div></div></div>`;
    }
}
SignUp.styles = css_248z;
__decorate([
    n({ type: Boolean })
], SignUp.prototype, "isBottom", void 0);
__decorate([
    n({ type: String })
], SignUp.prototype, "headline", void 0);
__decorate([
    n({ type: String })
], SignUp.prototype, "bodyText", void 0);
__decorate([
    n({ type: Boolean })
], SignUp.prototype, "rtl", void 0);
customElements.define('sign-up', SignUp);

export { SignUp };
